'use strict';
import authHook from "./routerAuthHook";
import bodyClassHook from "./bodyClassHook";
import overviewHook from "./overviewHook";
import adminLteFixHook from "./adminLteFixHook";

export default (store, router) => {
  router.beforeEach(authHook(store));
  router.beforeEach(bodyClassHook());
  router.beforeEach(overviewHook(store));
  router.beforeEach(adminLteFixHook());
};



// WEBPACK FOOTER //
// ./client/router/hooks/index.js